import { BusinessType } from '../../../types';

export const CATEGORY_PRIORITIES: Record<BusinessType | string, string[]> = {
  solopreneur: [
    'Project Management',
    'Accounting',
    'Time Tracking',
    'Marketing',
    'Scheduling'
  ],
  startup: [
    'Project Management',
    'Analytics',
    'Customer Support',
    'DevOps',
    'Sales & CRM'
  ],
  'small-business': [
    'Accounting',
    'Project Management',
    'Payment Processing',
    'Sales & CRM',
    'Document Management',
    'Scheduling'
  ],
  freelancer: [
    'Time Tracking',
    'Project Management',
    'Freelance Management',
    'Accounting',
    'Scheduling',
    'Payment Processing'
  ],
  trades: [
    'Field Service',
    'Scheduling',
    'Payment Processing',
    'Accounting',
    'Sales & CRM'
  ],
  'side-hustler': [
    'Marketing',
    'E-commerce',
    'Payment Processing',
    'Social Media Management',
    'Website Building',
    'Time Tracking'
  ],
  'agency': [
    'Project Management',
    'Time Tracking',
    'Sales & CRM',
    'Collaboration',
    'Analytics',
    'Accounting'
  ],
  'content-creator': [
    'Social Media Management',
    'Marketing',
    'Design & Creative',
    'Video & Streaming',
    'Project Management',
    'Scheduling'
  ],

  'saas': [
    'DevOps',
    'Analytics',
    'Customer Support',
    'Sales & CRM',
    'Payment Processing',
    'Project Management'
  ],
  'e-commerce': [
    'E-commerce',
    'Payment Processing',
    'Marketing',
    'Analytics',
    'Customer Support',
    'Email Services'
  ],
  'consulting-firm': [
    'Scheduling',
    'Document Management',
    'Sales & CRM',
    'Time Tracking',
    'Accounting',
    'Project Management'
  ],
  'service-business': [
    'Scheduling',
    'Sales & CRM',
    'Payment Processing',
    'Customer Support',
    'Accounting'
  ],
  'plumbing': [
    'Field Service',
    'Scheduling',
    'Payment Processing',
    'Accounting',
    'Sales & CRM'
  ],
  'electrical': [
    'Field Service',
    'Scheduling',
    'Payment Processing',
    'Accounting',
    'Sales & CRM'
  ],
  'hvac': [
    'Field Service',
    'Scheduling',
    'Payment Processing',
    'Sales & CRM',
    'Accounting'
  ],
  'landscaping': [
    'Field Service',
    'Scheduling',
    'Accounting',
    'Sales & CRM',
    'Payment Processing'
  ],
  'cleaning': [
    'Scheduling',
    'Field Service',
    'Sales & CRM',
    'Payment Processing',
    'Accounting'
  ],
  'carpentry': [
    'Field Service',
    'Project Management',
    'Accounting',
    'Scheduling',
    'Payment Processing'
  ],
  'consulting': [
    'Scheduling',
    'Sales & CRM',
    'Accounting',
    'Document Management',
    'Time Tracking'
  ],
  'coaching': [
    'Scheduling',
    'Payment Processing',
    'Marketing',
    'Email Services',
    'Website Building'
  ],
  'online-business': [
    'E-commerce',
    'Marketing',
    'Payment Processing',
    'Email Services',
    'Analytics'
  ],
  'marketplace': [
    'E-commerce',
    'Payment Processing',
    'Analytics',
    'Customer Support',
    'Marketing'
  ]
};
